/**
 * Where to resume after a re-authentication a screen asked for. The OIDC redirect always lands on `/`
 * ([RootRedirect]), so the screen notes its own path first. Kept per tab in sessionStorage, and only an
 * in-app venue path is honoured, so nothing stored here can send anyone off the app.
 */
const KEY = "tb_return_path";

export function rememberReturnPath(path: string): void {
  sessionStorage.setItem(KEY, path);
}

export function peekReturnPath(): string | null {
  const path = sessionStorage.getItem(KEY);
  return path?.startsWith("/v/") ? path : null;
}

export function clearReturnPath(): void {
  sessionStorage.removeItem(KEY);
}
